import React, { useState } from 'react';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import { ArrowLeft, Calendar, Clock, Building2, MapPin, DollarSign, Users, TrendingUp, FileText, Briefcase, Target, MessageSquare, Brain, CheckCircle, AlertCircle, ExternalLink, Plus, X, Loader } from 'lucide-react';

const InterviewDetails = ({ 
interview
 }) => {


return (
<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
<h2 className="text-xl font-bold text-gray-900 mb-4">Interview Details</h2>
<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
<div>
<p className="text-sm text-gray-600 mb-1">Interview Type</p>
<p className="font-medium text-gray-900">{interview.interviewType}</p>
</div>
<div>
<p className="text-sm text-gray-600 mb-1">Duration</p>
<p className="font-medium text-gray-900">{interview.duration}</p>
</div>
<div>
<p className="text-sm text-gray-600 mb-1">Location</p>
<p className="font-medium text-gray-900">{interview.location}</p>
</div>
<div>
<p className="text-sm text-gray-600 mb-1">Salary Range</p>
<p className="font-medium text-gray-900">{interview.salary}</p>
</div>
</div>

{interview.interviewers && interview.interviewers.length > 0 && (
<div className="mt-4 pt-4 border-t border-gray-200">
<p className="text-sm text-gray-600 mb-2">Interviewers</p>
<div className="space-y-2">
{interview.interviewers?.map((interviewer, index) => (
<div key={index} className="flex items-center gap-2">
<div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
<Users className="w-4 h-4 text-blue-600" />
</div>
<span className="text-gray-900">{interviewer.name} <br/><span className="text-xs">{interviewer.title}</span> </span>
</div>
))}
</div>
</div>
)}

</div>
);
};

export default InterviewDetails;